import { z } from 'zod';

/**
 * Zod schema for the POST /suppliers/relevance request payload.
 */
export const zodPostSuppliersRelevancePayloadSchema = z.object({
  dataExchangeId: z.uuid(),
  isRelevant: z.boolean(),
});
